
// import React from "react";


// import { Button } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import EmailCrm from "./EmailSmtpIntegration";
// import OutlookIntegration from "./OutlookIntegration";



// export default function EmailContainer() {
//   const navigate = useNavigate();

//   const isOutlookConnected = localStorage.getItem("outlook_connected") === "true";
//   const hasGmailToken = !!sessionStorage.getItem("email_access_token");
//   const sessionService = sessionStorage.getItem("email_service");

//   if (isOutlookConnected) {
//     if (sessionService !== "outlook") {
//       sessionStorage.setItem("email_service", "outlook");
//     }
//     return <OutlookIntegration />;
//   }

//   if (hasGmailToken && sessionService === "gmail") {
//     return <EmailCrm />;
//   }

//   return (
//     <div className="p-5 text-center">
//       <p>No email account connected</p>
//       <Button onClick={() => navigate("/email-settings")}>
//         Connect Email Account
//       </Button>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EmailCrm from "./EmailSmtpIntegration";
import OutlookIntegration from "./OutlookIntegration";

export default function EmailContainer() {
  const navigate = useNavigate();

  // sessionStorage is per-tab, so it can be empty/stale in a new or other
  // tab even when Outlook is actually connected. localStorage.outlook_connected
  // is shared across tabs, so treat it as the source of truth for Outlook.
  const isOutlookConnected = localStorage.getItem("outlook_connected") === "true";
  const hasGmailToken = !!sessionStorage.getItem("email_access_token");
  const sessionService = sessionStorage.getItem("email_service");
  const isConnected = isOutlookConnected || (hasGmailToken && sessionService === "gmail");

  useEffect(() => {
    if (!isConnected) {
      navigate("/email-settings", { replace: true });
    }
  }, [isConnected, navigate]);

  if (isOutlookConnected) {
    if (sessionService !== "outlook") {
      sessionStorage.setItem("email_service", "outlook");
    }
    return <OutlookIntegration />;
  }

  if (hasGmailToken && sessionService === "gmail") {
    return <EmailCrm />;
  }

  return (
    <div className="p-5 text-center">
      <Spinner animation="border" size="sm" />
    </div>
  );
}